'use strict'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Multiselect from 'vue-multiselect'
import { FAMixin, util } from 'pevueglobal'
import Vue from 'vue'
import locStore from 'store2'
import { sync } from 'vuex-pathify'
import { isAfter } from 'date-fns'
import VueHtml2pdf from 'vue-html2pdf'
import downloadexcel from 'vue-json-excel'

export default {
  mixins: [FAMixin],
  data: function () {
    return {
      role: null,
      tblpersonid: null,
      json_fields: {
        Datum: {
          field: 'tblPersonActivityDateCompleted',
          callback: (value) => {
            return `${this.$options.filters.formatDate(new Date(value))}`
          },
        },
        Categorie: 'categoryname',
        Omschrijving: 'tblPersonPEActivityDescription',
        Punten: 'tblPersonPEActivityCalcPoints',
        Status: 'statustxt',
      },
    }
  },
  async mounted() {
    this.getTexten()
    this.role = this.$route.params.role
    // er moeten 2 parameters worden gebruikt. personid (de persoon die men wil inzien) en boolPopupModus (is het scherm in een popup(1) of niet(0) )
    let boolpopupmodus = 0
    let inputdata = {}
    if (this.role === 'beheer') {
      boolpopupmodus = parseInt(this.$route.params.boolPopupModus)
      this.tblpersonid = parseInt(this.$route.params.personid)
      inputdata = {
        role: this.role,
        tblpersonid: this.tblpersonid,
        boolPopupModus: boolpopupmodus,
      }
    } else {
      inputdata = {
        role: this.role,
      }
    }

    await this.getactivity(inputdata)
    this.stopLoading()

    this.setPdfLogo()
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapGetters('SPE021PEActiviteiten', [
      'activityTable',
      'categorielist',
      'labels',
      'settings',
      'graphdata',
      'waiter',
    ]),
    activitySettings: sync('SPE021PEActiviteiten/activitySettings'),
    btnToevoegenVisible: function () {
      // Toevoegen button tonen als men in activitySettings.overzichtActiviteit zit en de button mag ook getoond worden.
      if (this.activitySettings.btnToevoegenSetting === true && this.activitySettings.overzichtActiviteit === true) {
        return true
      }
    },
    btnExcelDisable: function () {
      // Als er regels geselecteerd zijn dan moet buttonprint excel enabled zijn.
      return (
        !this.activitySettings.tableview.some((row, index) => this.activitySettings.shareSelected[index] === true) ||
        this.activitySettings.btnExcelDisabled
      )
    },
    btnPdfDisable: function () {
      // Als er regels geselecteerd zijn dan moet buttonprint pdf enabled zijn.
      return (
        !this.activitySettings.tableview.some((row, index) => this.activitySettings.shareSelected[index] === true) ||
        this.activitySettings.btnPDFDisabled
      )
    },
    multiSearchable: function () {
      if (this.activitySettings.hasMobile === true) {
        return false
      } else {
        return true
      }
    },
    multiCloseOnSelect: function () {
      if (this.activitySettings.hasMobile === true) {
        return true
      } else {
        return false
      }
    },

    htmlToPdfOptions() {
      return {
        margin: 10,

        filename: 'Activities.pdf',

        image: {
          type: 'jpeg',
          quality: 1,
        },

        enableLinks: true,

        html2canvas: {
          scale: 2,
          useCORS: true,
          // Deze zijn belangrijk anders kan er een blanko PDF gegenereerd worden vanwege scrolling
          scrollX: 0,
          scrollY: 0,
        },

        jsPDF: {
          format: 'a4',
          orientation: 'landscape',
        },

        // Enable all 'modes', with no explicit elements.
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      }
    },

    tableColumnsWithoutSelectBox: {
      get() {
        if (!this.activityTable.tablecolumnsetting || this.activityTable.tablecolumnsetting.lenght === 0) {
          return []
        }
        return this.activityTable.tablecolumnsetting.filter(
          (row, index) =>
            row.name !== 'tblPersonPEActivityCheckbox' &&
            row.name !== 'TblPersonPEActivityCheckbox' &&
            row.name !== 'statustxt' &&
            row.name !== 'Statustxt'
        )
      },
    },

    selectedTableData: {
      get() {
        if (!this.activityTable.tabledata || this.activityTable.tabledata.lenght === 0) {
          return []
        }

        const tableviewChecked = this.activitySettings.tableview.filter(
          (row, index) => this.activitySettings.shareSelected[index] === true
        )

        // could nog get this.activitySettings.tableview to work so filtered tabledata as for now.
        const tablDataChecked = this.activityTable.tabledata.filter((item1) =>
          tableviewChecked.some((item2) => item1.tblPersonActivityID === item2.tblPersonActivityID)
        )

        return tablDataChecked
      },
    },
  },
  methods: {
    isAfter,
    ...mapActions('SPE021PEActiviteiten', ['getTexten', 'getactivity', 'getGraphUrl']),
    ...mapMutations('SPE021PEActiviteiten', [
      'XVTablesort',
      'XVtablecolumnsettingchanged',
      'XVtableSetRowStateProperty',
      'resetreportstatus',
      'setActivitySetting',
    ]),
    valTotDiv() {
      if (this.activitySettings.ienddate !== '') {
        this.$validator.validate()
      }
    },
    valVanDiv() {
      if (this.activitySettings.istartdate !== '') {
        this.$validator.validate()
      }
    },
    formatpoints: function (val) {
      return util.FormatStringDecimal(val)
    },
    openwindow: function (url) {
      // Open window in new tab.
      window.open('/' + url, 'SPE024', 'width=600, height=400, menubar=no, resizable=yes toolbar=no')
    },
    checkstring024: function (url) {
      // check if url contains sp024.
      var check = false
      if (url.includes('beheer/SPE024_BH')) {
        check = true
      }
      return check
    },
    filterfunc: function (tabledata) {
      var Itabledata = tabledata
      //   let multi
      Itabledata = tabledata.filter((n, index) => {
        let van =
          this.activitySettings.zoekDatumVan === null ||
          new Date(n.tblPersonActivityDateCompleted) >= this.activitySettings.zoekDatumVan
        let tot =
          this.activitySettings.zoekDatumTot === null ||
          new Date(n.tblPersonActivityDateCompleted) <= this.activitySettings.zoekDatumTot
        // let multi = this.activitySettings.multiselected.indexOf(n.tblProfGroupCategoryID) !== -1

        //     if ($('html').hasClass('mobile') && this.selallCatMobileSelected === true){
        //         multi = true
        //     } else {
        let multi =
          this.activitySettings.multiselectedfilter.find(
            (m) => m.tblProfGroupCategoryID === n.tblProfGroupCategoryID || m.tblProfGroupCategoryID === null
          ) !== undefined
        //     }
        // alleen filteren op omschrijving als deze gevuld isin de tabelMaaki2020!

        var omschrZichtbaar = false
        Itabledata.forEach((datarow) => {
          if (datarow.tblPersonPEActivityDescription !== null) {
            omschrZichtbaar = true
          }
        })
        if ((omschrZichtbaar === true) & (this.activitySettings.zoekTbxOmschrijving !== '')) {
          let omschr
          if (typeof n.tblPersonPEActivityDescription === 'string') {
            omschr =
              this.activitySettings.zoekTbxOmschrijving === '' ||
              n.tblPersonPEActivityDescription
                .toString()
                .toLowerCase()
                .includes(this.activitySettings.zoekTbxOmschrijving.toLowerCase())
          }
          return van && tot && multi && omschr
        } else {
          return van && tot && multi
        }
      })

      // Kijken if er data gevuld is in bepaalde columns. Als er geen data is dan kan de column op invisible gezet worden.
      // 1e check of tblPersonPEActivityPEPoints gevuld is
      var countrows = false
      Itabledata.forEach((datarow) => {
        if (datarow.tblPersonPEActivityPEPoints !== null) {
          countrows = true
        }
      })
      if (countrows === false) {
        // Geen waardes gevonden dus column op invisible. Waarde 0 (false)
        this.XVtablecolumnsettingchanged({
          column: 'tblPersonPEActivityPEPoints',
          visible: 0,
        })
      } else {
        // Wel een waarde gevonden dus column op visible. Waarde 1 (true)
        this.XVtablecolumnsettingchanged({
          column: 'tblPersonPEActivityPEPoints',
          visible: 1,
        })
      }
      // 3e check of statustxt gevuld is
      countrows = false
      Itabledata.forEach((datarow) => {
        if (datarow.statustxt !== null) {
          countrows = true
        }
      })
      if (countrows === false) {
        // Geen waardes gevonden dus column op invisible. Waarde 0 (false)
        this.XVtablecolumnsettingchanged({
          column: 'statustxt',
          visible: 0,
        })
      } else {
        // Wel een waarde gevonden dus column op visible. Waarde 1 (true)
        this.XVtablecolumnsettingchanged({
          column: 'statustxt',
          visible: 1,
        })
      }
      return Itabledata
    },
    tablefilter: function () {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.setActivitySetting({
            zoekDatumVan: this.activitySettings.istartdate,
            zoekDatumTot: this.activitySettings.ienddate,
            multiselectedfilter: this.activitySettings.multiselected,
            zoekTbxOmschrijving: this.activitySettings.tbxOmschrijving,
          })
          // Bij veranderen van filter deze in de localstore zetten zodat die later weer gebruikt kan worden als men terug naar deze pagina gaat.
          let lstore = locStore.namespace('SPE021PEActiviteiten')
          lstore.session('startdate', this.activitySettings.zoekDatumVan)
          lstore.session('enddate', this.activitySettings.zoekDatumTot)
          lstore.session('categories', this.activitySettings.multiselectedfilter)
          lstore.session('omschrijving', this.activitySettings.zoekTbxOmschrijving)
        }
      })
    },
    clearfilter: function () {
      this.activitySettings.multiselected.forEach((n, i) => {
        this.activitySettings.multiselected.splice(0, this.activitySettings.multiselected.length)
        this.activitySettings.multiselected.unshift({
          categoryname: this.activitySettings.firstItemCatlist,
          tblProfGroupCategoryID: null,
        })
      })
      this.setActivitySetting({
        istartdate: null,
        ienddate: null,
        zoekDatumVan: this.activitySettings.istartdate,
        zoekDatumTot: this.activitySettings.ienddate,
        btnwis: false,
        multiselectedfilter: this.activitySettings.multiselected,
        tbxOmschrijving: '',
        zoekTbxOmschrijving: '',
      })
      this.tablefilter()
    },
    multiselectInput: function (value, id) {
      // Als "all-categorien" is geslecteerd en men selecteerd een echte categorie dan moet "all-categorien" verwijderd worden.
      let alleCategorieen = false
      this.activitySettings.multiselected.forEach((n, i) => {
        if (n.tblProfGroupCategoryID === null) {
          alleCategorieen = true // "alle categorieen" staat geselecteerd
        }
      })
      // Als er meer dan 2 categorieen zijn geselecteerd waarvan "all-categorien" dan deze verwijderen.
      if (this.activitySettings.multiselected.length > 1) {
        if (alleCategorieen === true) {
          this.activitySettings.multiselected.splice(0, this.activitySettings.multiselected.length - 1)
        }
      }
      // als de geselecteerde categorien worden verwijderd, en er niets zou overblijven, komt altijd "all-categorien" terug.
      if (this.activitySettings.multiselected.length === 0) {
        this.activitySettings.multiselected.unshift({
          categoryname: this.translation(14456),
          tblProfGroupCategoryID: null,
        })
      }
    },
    multiselectClose: function (value, id) {
      // Bij verlaten categorie filter en er is geen categorie geselecteerd dan op "alle categorien" zetten.
      if (this.activitySettings.multiselected.length === 0) {
        this.activitySettings.multiselected.unshift({
          categoryname: this.translation(14456),
          tblProfGroupCategoryID: null,
        })
      }
    },
    btnToevoegen: function () {
      // Toevoegen knop. Is afhankelijk van setting en kan presentie zijn of een activiteit.
      if (this.role !== 'beheer') {
        if (this.settings.intSettingDialog === 1) {
          window.location = '/wizards/wizardoverigeactiviteit/wzr_overige_activiteit_step_00.aspx'
        }
        if (this.settings.intSettingDialog === 2) {
          window.location = '/allroles/wizards/Wizardpresentie/wzr_pres_step_00.aspx'
        }
        if (this.settings.intSettingDialog === 0) {
          window.location = '/prof/SPE023_PR_ToevoegenActiviteit.aspx'
        }
      }
      if (this.role === 'beheer') {
        window.location = '/beheer/SPE023_BH_ToevoegenActiviteit.aspx?id=' + this.tblpersonid
      }
    },
    btnShare: function () {
      // if(this.activitySettings.tableview.length > 75){
      //   this.activitySettings.delenTableSettings = JSON.parse(JSON.stringify(this.activityTable.tablesetting))
      //   this.activitySettings.delenTableSettings.tblPEapiProcTableActivitySettings.pagingsize = 20
      //   this.activitySettings.paging = true
      // } else {
      //   this.activitySettings.paging = false
      // }

      // Naar delenactiviteiten pagina
      this.setActivitySetting({
        delenActiviteit: true,
        toggleSelectAllValue: false,
        pdfdownloaddata: undefined,
        exceldownloaddata: undefined,
        shareSelected: [],
        overzichtActiviteit: false,
        paging: false,
      })
      this.XVtablecolumnsettingchanged({
        column: 'tblPersonPEActivityCheckbox',
        visible: 1,
      })
      util.newpageinit()

      setTimeout(() => {
        this.setActivitySetting({
          delenActiviteitXVtableshow: true,
        })
      }, 200)
    },
    btnTerug: function () {
      this.resetreportstatus()
      // Terug naar hoofd pagina met overzicht activiteiten
      this.setActivitySetting({
        delenActiviteit: false,
        delenActiviteitXVtableshow: false,
        overzichtActiviteit: true,
        shareSelected: [],
        paging: true,
      })
      this.XVtablecolumnsettingchanged({
        column: 'tblPersonPEActivityCheckbox',
        visible: 0,
      })
    },
    btnExcel: async function () {
      // Excel maken van de geselecteerde activiteiten
      let columns = [
        {
          name: 'tblPersonActivityDateCompleted',
          type: 'date',
        },
        {
          name: 'categoryname',
          type: 'string',
        },
        {
          name: 'tblPersonPEActivityDescription',
          type: 'string',
        },
        {
          name: 'tblPersonPEActivityPEPoints',
          type: 'decimal',
        },
        {
          name: 'statustxt',
          type: 'string',
        },
      ]
      this.setActivitySetting({
        btnExcelDisabled: true,
        exceldownloaddata: undefined,
      })
      // filteren gecheckte rijen en die in de excel zetten
      let tableviewChecked = this.activitySettings.tableview.filter(
        (row, index) => this.activitySettings.shareSelected[index] === true
      )

      tableviewChecked = util.PrepareTableForExport(tableviewChecked, this.activityTable.tablecolumnsetting, columns)

      this.activitySettings.exceldownloaddata = await util.GenerateFile('public/DatatabletoExcel', {
        DataTable: tableviewChecked,
        DefinitionTable: columns,
        FileName: 'Activities.xlsx',
        local: false, // lokaal afvuren voor debuggen en templating in dev modus
      })

      this.activitySettings.exceldownloaddata.url = util.createApiUrl(this.activitySettings.exceldownloaddata.url)
      this.setActivitySetting({
        btnExcelDisabled: false,
      })
    },
    btnPDF: async function () {
      // filteren gecheckte rijen en die in de pdf zetten
      // let columns = [
      //   {name: 'tblPersonActivityDateCompleted', type: 'string',order: 0},
      //   {name: 'categoryname', type: 'string',order: 1},
      //   {name: 'tblPersonPEActivityDescription', type: 'string',order: 2},
      //   {name: 'tblPersonPEActivityPEPoints', type: 'string',order: 3},
      //   {name: 'statustxt', type: 'string',order: 4}
      // ]
      this.setActivitySetting({
        btnPDFDisabled: true,
        pdfdownloaddata: undefined,
      })
      // filteren gecheckte rijen en die in de excel zetten
      let tableviewChecked = this.activitySettings.tableview.filter(
        (row, index) => this.activitySettings.shareSelected[index] === true
      )
      tableviewChecked = util.PrepareTableForExportPDF(tableviewChecked, this.activityTable.tablecolumnsetting)

      this.activitySettings.pdfdownloaddata = await util.GenerateFile('public/DatasettoPDF', {
        DataSet: {
          DataforPDF: tableviewChecked,
          DataColumnsforPDF: this.activityTable.tablecolumnsetting,
        },
        filename: 'Activities.pdf', // downloadnaam
        template: 'pdfspe021prpeactiviteiten', // pdf vue template
        pdfPreviewInBrowser: false, // pdf viewer https://mozilla.github.io/pdf.js/
        htmlpreview: false, // html preview voor debuggen en templating in dev modus (PRODUCTION zorgt ervoor dat dit in production overruled word)
        local: false, // lokaal afvuren voor debuggen en templating in dev modus
        clientcss: $('link[href*="clients"]').attr('href'),
        PageOrientation: 'landscape', // afdrukken in portrait of landscape
        // vergeet niet dat je de api lokaal ook op de goede db connectie moet zetten
        // als je de html preview op 1200px zet
      })
      this.activitySettings.pdfdownloaddata.url = util.createApiUrl(this.activitySettings.pdfdownloaddata.url)
      this.setActivitySetting({
        btnPDFDisabled: false,
      })
    },
    rowselected: function () {
      this.setActivitySetting({
        toggleSelectAllValue: false,
      })
    },
    toggleSelect: function () {
      // Alles selecteren of de-selecteren waarna men deze kan downloaden.

      this.activitySettings.tableview.forEach((datarow, index) => {
        if (this.activitySettings.toggleSelectAllValue === true) {
          Vue.set(this.activitySettings.shareSelected, index, true)
        } else {
          Vue.set(this.activitySettings.shareSelected, index, false)
        }
      })
    },
    graphClick: function (graphClickinfo) {
      let roleshort = this.role === 'beheer' ? 'BH' : 'PR'

      const graphGetUrlinputApi = {
        pagename: 'SPE021_' + roleshort + '_PEActiviteiten.aspx',
        clientid: '',
        filters: [
          {
            key: 'startdate',
            datevalue: util.DateForDatabase(this.activitySettings.istartdate),
          },
          {
            key: 'enddate',
            datevalue: util.DateForDatabase(this.activitySettings.ienddate),
          },
        ],
        graphIDForUrl: graphClickinfo.graphID,
        defaultfilter: '',
      }

      if (this.role === 'beheer') {
        let personfilter = {
          key: 'personid',
          intvalue: this.$route.params.personid,
        }
        graphGetUrlinputApi.filters.push(personfilter)
      }
      // setup categorie data
      let CommaSepCat = ''

      if (this.activitySettings.multiselected[0].tblProfGroupCategoryID !== null) {
        // check op alle categoerieen
        this.activitySettings.multiselected.forEach((v) => {
          CommaSepCat += v.tblProfGroupCategoryID.toString() + ','
        })
        if (this.activitySettings.multiselected.length > 0) {
          CommaSepCat = CommaSepCat.substring(0, CommaSepCat.length - 1)
        }

        graphGetUrlinputApi.filters.push({
          key: 'categorie',
          value: CommaSepCat,
        })
      }

      this.getGraphUrl({
        graphGetUrlinputApi: graphGetUrlinputApi,
        graphShowInPopup: graphClickinfo.graphShowInPopup,
      })
    },

    // PDF
    async downloadPdf() {
      this.$refs.html2Pdf.generatePdf()
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      // the logo
      const firstElement = document.getElementById('pdf-logo')
      // the possible page break element or the table wrapped in a div
      const secondElement = firstElement.parentElement.children[1]
      // third element is the table wrapped in a div

      // if the second element is a page break then remove, because its unnecessary
      if (secondElement.classList.contains('html2pdf__page-break')) {
        firstElement.parentElement.removeChild(secondElement)
      }
    },

    async hasDownloaded({ html2pdf, options, pdfContent }) {},

    // The logo comes from the (client)ccs, but its styled on the id
    // so the style needs to be copied to the pdf-logo element
    setPdfLogo() {
      let logo = getComputedStyle(document.getElementById('PElogo')).getPropertyValue('background')
      if (!logo.includes('url(')) {
        logo = getComputedStyle(document.getElementById('PElogo')).getPropertyValue('background-image')
      }
      if (!logo.includes('url(')) {
        logo = getComputedStyle(document.getElementById('PEleftbackgr')).getPropertyValue('background')
      }
      if (!logo.includes('url(')) {
        logo = getComputedStyle(document.getElementById('PEleftbackgr')).getPropertyValue('background-image')
      }
      if (!logo.includes('url(')) {
        logo = getComputedStyle(document.getElementById('PErightbackgr')).getPropertyValue('background')
      }
      if (!logo.includes('url(')) {
        logo = getComputedStyle(document.getElementById('PErightbackgr')).getPropertyValue('background-image')
      }

      document.getElementById('pdf-logo').style.background = logo
      document.getElementById('pdf-logo').style.height = '150px'
    },

    // EXCEL
    // FetchData for the Excel generation
    async fetchData() {
      if (
        this.selectedTableData.every(
          (d) => d.tblPersonPEActivityPEPoints === null || d.tblPersonPEActivityPEPoints === ''
        )
      ) {
        delete this.json_fields['Punten']
      } else {
        this.json_fields['Punten'] = 'tblPersonPEActivityCalcPoints'
      }

      if (this.selectedTableData.every((d) => d.statustxt === null || d.statustxt === '')) {
        delete this.json_fields['Status']
      } else {
        this.json_fields['Status'] = 'statustxt'
      }

      return this.selectedTableData
    },
    startDownload() {
      // console.log('show loading')
    },
    finishDownload() {
      // console.log('hide loading')
    },
  },
  components: {
    Multiselect,
    VueHtml2pdf,
    downloadexcel,
  },
}
